import * as actionTypes from '../../actions';

const initialState = {
    groupings: [],
}

const reducer = (state = initialState, action) => {

    switch (action.type) {

        case actionTypes.SET_GROUPINGS:

            return {
                ...state,
                groupings: action.payload.data,
            }

        default: return state;

    }

}

export default reducer;